import { useEffect, useRef } from 'react'
import { authPort } from '@/infra/config/beans'

const CallbackTokenPage = () => {
  const processed = useRef(false)

  useEffect(() => {
    if (processed.current) return
    processed.current = true
    ;(async () => {
      try {
        const { returnTo } = await authPort.handleSigninCallback()
        const redirect = returnTo === '/token' ? '/' : returnTo || '/'
        window.location.replace(redirect)
      } catch (e) {
        console.error('Erreur callback OIDC:', e)
      } finally {
        sessionStorage.removeItem('auth:inflight')
      }
    })()
  }, [])

  return null
}

export default CallbackTokenPage
